

export default function Section2() {

  return (
    <div className="container-1280 w-full Section5">
      <div className="w-full section5-container">
        <div className="w-[95%] md:w-[95%] md:w-100 mx-auto text-center mt-10 mb-5">
          <h1 className="text-[26px] md:text-[34px] font-bold mb-5 text-[#da2128]">Careers at Mean3</h1>
          <p className="text-[14px] font-open text-[#000] font-bold leading-normal">
            At Mean3, you will work with a dedicated team of developers, digital marketers, and thought leaders who aspire to shape the future of eCommerce. The foundation of Mean3 is built on 4Cs
          </p>
        </div>
      </div>
    </div>
  );
}
